// © 2015-2021 WDNA - All Rights Reserved

import Login from './containers/Login';
import Forgot from './containers/Forgot';
import Logout from './containers/Logout';

export const redirects: any[] = [];

export const routes: any[] = [
  {
    component: Login,
    path: '/login'
  },
  {
    component: Forgot,
    path: '/forgot'
  },
  {
    component: Logout,
    path: '/logout'
  }
];
